export default __webpack_public_path__ + "assets/menu-close_dark.473ab5ce.svg";